import Api from "./api";
import { getTimestamp, validateBase64 } from "../utils";
import Global from "../global";
import FileType from "../enum/file-type";

class FileServerSingleton {

    private SystemLocalSeparator: string = '__';

    /* Public Methods */

    public async saveImage(entityId: number, fieldId: number, docId: number, base64: string): Promise<string> {
        const system: string = `${entityId}-${fieldId}-${docId}`;
        const type: string = this.getImageType(base64);
        const local: string = `${Global.DEFAULT_DOC_IMG_NAME}.${type}`;
        const filename: string = this.getFileName(FileType.DocImage, system, local);
        if (type) {
            return await Api.sendFile(filename, validateBase64(base64));
        } else {
            return '';
        }
    }

    public async saveAppLogo(appId: string, base64: string): Promise<string> {
        const system: string = `${appId}`;
        const type: string = this.getImageType(base64);
        const local: string = `${Global.DEFAULT_DOC_IMG_NAME}.${type}`;
        const filename: string = this.getFileName(FileType.AppLogo, system, local);
        if (type) {
            return await Api.sendFile(filename, validateBase64(base64));
        } else {
            return '';
        }
    }

    public async delete(filename: string): Promise<string> {
        return Api.deleteFile(filename);
    }

    public getFileUrl(filename: string): string {
        return Api.getFileUrl(filename);
    }

    /* Private Methods */

    private getFileName(type: FileType, system: string, local: string): string {
        return `${type}_${system}_${getTimestamp()}${this.SystemLocalSeparator}${local}`;
    }

    private getImageType(base64: string): string {
        const before: string = 'data:image/';
        const after: string = ';base64,';
        return base64.slice(base64.indexOf(before) + before.length, base64.indexOf(after));
    }

}

const FileServer = new FileServerSingleton();

export default FileServer;